import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { RadioComponent } from '../../ui/form/radio';
import { StoreDecorator } from './../../catalog/model/store/store.decorator';
import { CheckoutCollectionComponent } from './checkout-collection.component';
import { MetapackCollectionPoint } from './metapack/metapack-collection-point';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'checkout-collection-list',
    templateUrl: './checkout-collection-list.html',
    standalone: true,
    imports: [CommonModule, FormsModule, OrdinalPipe, RadioComponent, RadioGroupDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutCollectionListComponent {
    @Input()
    list?: StoreDecorator[] | MetapackCollectionPoint[];

    @Input()
    model?: number | string | null;

    constructor(
        protected checkoutCollectionComponent: CheckoutCollectionComponent,
        protected changeDetectorRef: ChangeDetectorRef
    ) {}

    get leadTime(): string | undefined {
        return this.checkoutCollectionComponent?.leadTime;
    }

    select(model: StoreDecorator | MetapackCollectionPoint): void {
        this.checkoutCollectionComponent.selectModel(model);
    }

    trackByStore(index: number, model: StoreDecorator | MetapackCollectionPoint): string {
        const id = typeof model.id === 'string' ? model.id : model.id.toString();
        return id + model.distance;
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
